import { render, staticRenderFns } from "./HezuoWarn.vue?vue&type=template&id=19df08e8&scoped=true&"
import script from "./HezuoWarn.vue?vue&type=script&lang=js&"
export * from "./HezuoWarn.vue?vue&type=script&lang=js&"
import style0 from "./HezuoWarn.vue?vue&type=style&index=0&id=19df08e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df08e8",
  null
  
)

export default component.exports